import { motion } from "framer-motion";
import { Zap, ArrowRight, Music, FileVideo } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export const StemAutoRouting = ({ enabled, onToggle }) => {
  return (
    <div
      className="bg-meta-surface border border-meta-border p-4"
      data-testid="stem-auto-routing"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Icon with animation */}
          <div
            className={`p-3 border transition-all duration-300 ${
              enabled
                ? "bg-meta-neon-dim border-meta-neon"
                : "bg-meta-base border-meta-border"
            }`}
          >
            <Zap
              size={20}
              className={enabled ? "text-meta-neon" : "text-meta-text-muted"}
            />
          </div>

          {/* Label */}
          <div>
            <h3 className="font-sans font-medium text-meta-text">
              Stem Auto-Routing
            </h3>
            <p className="text-sm text-meta-text-muted">
              Automatically pipe new mixdowns to render queue
            </p>
          </div>

          {/* Visual flow */}
          <div className="hidden md:flex items-center gap-2 ml-4">
            <div
              className={`flex items-center gap-2 px-3 py-1.5 border transition-colors ${
                enabled
                  ? "bg-meta-neon-dim border-meta-neon"
                  : "bg-meta-base border-meta-border"
              }`}
            >
              <Music size={14} className={enabled ? "text-meta-neon" : "text-meta-text-muted"} />
              <span className={`font-mono text-xs ${enabled ? "text-meta-neon" : "text-meta-text-muted"}`}>
                Mixdowns/
              </span>
            </div>

            <motion.div
              animate={{ x: enabled ? [0, 5, 0] : 0 }}
              transition={{ repeat: enabled ? Infinity : 0, duration: 1 }}
            >
              <ArrowRight
                size={16}
                className={enabled ? "text-meta-neon" : "text-meta-text-muted"}
              />
            </motion.div>

            <div
              className={`flex items-center gap-2 px-3 py-1.5 border transition-colors ${
                enabled
                  ? "bg-meta-neon-dim border-meta-neon"
                  : "bg-meta-base border-meta-border"
              }`}
            >
              <FileVideo size={14} className={enabled ? "text-meta-neon" : "text-meta-text-muted"} />
              <span className={`font-mono text-xs ${enabled ? "text-meta-neon" : "text-meta-text-muted"}`}>
                Render Queue
              </span>
            </div>
          </div>
        </div>

        {/* Toggle */}
        <div className="flex items-center gap-3">
          <span
            className={`font-mono text-xs uppercase ${
              enabled ? "text-meta-neon" : "text-meta-text-muted"
            }`}
          >
            {enabled ? "Active" : "Inactive"}
          </span>
          <Switch
            checked={enabled}
            onCheckedChange={onToggle}
            className="data-[state=checked]:bg-meta-neon"
            data-testid="stem-routing-toggle"
          />
        </div>
      </div>

      {/* Status message */}
      {enabled && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="mt-4 pt-4 border-t border-meta-border"
        >
          <p className="text-xs font-mono text-meta-neon flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-meta-neon animate-pulse" />
            Monitoring /Mixdowns/ for new .wav files...
          </p>
        </motion.div>
      )}
    </div>
  );
};
